<template>
	<div class="container-fluid">
		<div class="row row-sorting-wrapper">
			<div
				class="sorting-item-column sorting-item-column-4"
				v-for="(singleSortableData, index) of this.sortingHeadings"
				:key="index"
			>
				<AspectTableSortingSingle
					:data="singleSortableData"
				/>
			</div>
		</div>
	</div>
</template>

<script>
const order = ['first_natal', 'aspects', 'last_natal']
import AspectTableSortingSingle from './AspectTableSortingSingle'
import SolFileAPIInstance from "@/api";

export default {
	name: "AspectTableSorting",
	components: {
		AspectTableSortingSingle
	},
	data() {
		return {
			sortingHeadings: []
		}
	},

  methods: {
    async fetchFilters() {
      const filters = await SolFileAPIInstance.getAspectFilters()
      const transformedFilters = Object.entries(filters.data).reduce((acc, item) => {
        const [label, values] = item
        const newItem = {
          label,
          values,
          currentValue: ''
        }
        acc.push(newItem)
        return acc
      }, [])
      this.sortingHeadings = order.map(item => transformedFilters.find(singleFilter => singleFilter.label === item))
    },
  },

  mounted() {
    this.fetchFilters()
  },

  watch: {
		sortingHeadings: {
			deep: true,
			handler() {
				this.$emit('on-sorting-change', this.sortingHeadings)
			}
		}
	}
}
</script>

<style scoped>

</style>